﻿
function registerCompareToValidator($: any): void {
    function parseValue(value: string): any {
        if (!value) return null;

        const date = new Date(value + "T00:00:00");
        if (!isNaN(date.getTime())) return date.getTime();

        const number = Number(value);
        if (!isNaN(number)) return number;

        return value;
    }

    $.validator.addMethod("compareto", function (value: string, element: HTMLElement, params: any) {
        if (!value) return true;

        const form = $(element).closest("form");
        const otherValue = form.find(`[name='${params.other}']`).val();

        if (!otherValue) return true;

        const current = parseValue(value);
        const other = parseValue(otherValue);

        switch (params.operator) {
            case "GreaterThan": return current > other;
            case "GreaterThanOrEqual": return current >= other;
            case "LessThan": return current < other;
            case "LessThanOrEqual": return current <= other;
            default: return true;
        }
    });

    $.validator.unobtrusive.adapters.add("compareto", ["other", "operator"], function (options: any) {
        options.rules["compareto"] = {
            other: options.params.other,
            operator: options.params.operator
        };

        options.messages["compareto"] = options.message;
    });

    $(document).on("change blur", "input, select, textarea", function (this: HTMLElement) {
        const changedName = $(this).attr("name");
        if (!changedName) return;

        const form = $(this).closest("form");

        form.find(`[data-val-compareto-other='${changedName}']`).each(function (this: HTMLElement) {
            $(this).valid();
        });
    });
}


(function ($) {
    registerCompareToValidator($);    
})(jQuery);